/**
 * Harness catalog tools are registered under dotted types
 * (`harness.oms.sales_order_metrics`) so they sit beside workflow tool ids.
 * Model providers only accept `[a-zA-Z0-9_-]` in a tool name, so the chat
 * agent offers each tool under its short name (`sales_order_metrics`), which
 * is also how the module instructions and skills refer to it. The frontend
 * renderer matches on the same short name.
 */
const HARNESS_TYPE_PREFIX = /^harness\.[a-z0-9-]+\./;

export function harnessChatToolName(type: string): string {
  return type.replace(HARNESS_TYPE_PREFIX, "").replace(/[^a-zA-Z0-9_-]/g, "_");
}

/** Chat tools whose result is a downloadable file, by chat name. */
export const HARNESS_DOWNLOAD_FILE_TOOLS: readonly string[] = [
  harnessChatToolName("harness.oms.export_sales_orders_csv"),
  harnessChatToolName("harness.oms.export_discounts_csv"),
];
